<div class="content-with-stepper-and-title front-document-scan">
  <main>
    <h2 class="sub-title offset-inline selfie-title" id="titleCheckDocumentInfo">{{ copyService.copies.check_document_info_texts.component_title }}</h2>
    <span id="subtitleCheckDocumentInfo" class="selfie-subtitle">{{ copyService.copies.check_document_info_texts.component_subtitle }}</span>
    <div class="document-container">
      <app-back-document-info *ngIf="active_face; else FrontDocument"></app-back-document-info>
      <ng-template #FrontDocument>
        <app-front-document-info></app-front-document-info>
      </ng-template>
      <div class="box_link">
        <vcl-link (click)="changeviewDocument()" [label]="active_face ? copyService.copies.check_document_info_texts.info_rear : copyService.copies.check_document_info_texts.info_frontal" class="termsLink" [linkId]="'changeDocumentPosition'">
        </vcl-link>
      </div>
    </div>
  </main>
  <app-controls [hasPrevious]="true" nextLabel="Continuar" (next)="next()"></app-controls>
</div>